// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] + "-" + {"125":"dce3d2091daf90d5c5ab","293":"4b8640f85ca2809b4d05"}[chunkId] + ".js";
};